/** @jsxImportSource @emotion/react */
import React from "react";
import * as commonSelectors from "./commonSelectors";
import { useSelector } from "react-redux";
import { css } from "@emotion/react";

type Props = {
  children: React.ReactNode;
};

const loadingWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AppShell = ({ children }: Props) => {
  const isAppReady = useSelector(commonSelectors.isAppReady);
  return (
    <>
      {!isAppReady ? (
        <div css={loadingWrapper}>
          <div className="loading-text">
            <span>LOADING</span>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};
